<template>
  <v-dialog v-model="show" max-width="406" flat elevation="0" persistent>
    <v-card color="greyColorLigthTwo" class="rounded-lg py-5">
      <v-card-title class="justify-center pb-0 mb-0">
        {{description}}
      </v-card-title>
      <v-card-actions class="justify-center align-center pb-5 mt-0">
        <v-btn
          :color="buttonColor"
          class="white--text text-capitalize"
          block
          elevation="0"
          rounded
          large
          @click="buttonClick()"
        >
          {{ $t("buttons.sendRequest") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <dialog-close-button @clickButton="show = false" />
  </v-dialog>
</template>

<script>
import  DialogCloseButton  from "./DialogCloseButton.vue";
export default {
  props: {
    buttonColor: {
      type: String,
      default: "defaultColorLightTwo",
    },
    description: {
        type: String,
        default: 'Canlı yayın talebiniz alınmıştır.Bilgileriniz kontrol edildikten sonra size dönüş yapılacaktır.',
    },
    visible: Boolean,
  },
  data: () => ({}),
  components:{
    DialogCloseButton
  },
  watch: {},
  methods:{
    buttonClick(){
        this.show = false
    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>

<style></style>
